<ng-container>
  @if (activeFilters.length > 0) {
    <div class="marked-filters">
      @for (filter of activeFilters; track filter.name) {
        <ul class="marked-filters__list">
          @for (option of filter.entities; track option) {
            <li class="filter__tile">
              <span
                class="filter__link"
                [attr.data-test]="'link-filter-' + filter.name"
                (click)="filterResults(filter.name, option, router.url)"
                (keydown.enter)="filterResults(filter.name, option, router.url)">
                <span [attr.data-test]="'desc-filter-' + filter.name" class="filter__name">{{ option }}</span>
                <span class="icon-close"></span>
              </span>
            </li>
          }
        </ul>
      }
    </div>
  }
</ng-container>
